import {
    AfterViewInit,
    Component,
    Input,
    OnInit,
    ViewChild,
    ChangeDetectorRef,
} from '@angular/core';
import {FormGroup} from '@angular/forms';

import {FormFieldBase} from '../../../interfaces/form-field-base/form-field-base';
import {DynamicFormFieldService} from '../../../services/dynamic-form-field.service';
import {BehaviorSubject} from 'rxjs';
import {
    DynamicManagementFormFieldComponent
} from '../../dynamic-form-field/dynamic-management-form-field/dynamic-management-form-field.component';


@Component({
    selector: 'emm-dynamic-management-form',
    templateUrl: './dynamic-management-form.component.html',
    styleUrls: ['./dynamic-management-form.component.scss'],
    standalone: false
})
export class DynamicManagementFormComponent implements OnInit, AfterViewInit {
    formFields: FormFieldBase<string>[] | null = [];
    formFields$ = new BehaviorSubject<FormFieldBase<string>[] | null>(null);
    @Input() locked: boolean;
    @Input() itemTag: string;
    @Input() itemTagPath: string;
    @Input() selectedSubmenu: string;
    @Input() effectiveDate: string;
    @Input() nodeId: string;
    @Input() selectedLocation: string;
    @Input() form!: FormGroup;
    @Input() locale: any;
    @Input() attributes: any;
    @Input() isAdd: boolean;
    @Input() isDuplication: boolean;
    @Input() existingUpdates: [];
    @Input() attributeGroupId: string;
    @Input() showLocaleIcons = true;
    @ViewChild(DynamicManagementFormFieldComponent) dynamicFormField: DynamicManagementFormFieldComponent<string>;

    model;

    constructor(
        public fieldService: DynamicFormFieldService,
        private changeDetector: ChangeDetectorRef,
    ) {
    }

    ngOnInit() {
        if (this.locked) {
            const lockedAttribute = {
                attributeGroup: '',
                tag: 'locked',
                name: 'Locked',
                jsonProperty: 'locked',
                description: '',
                values: [{
                    language: '',
                    country: 'US',
                    value: this.locked ? this.locked.toString() : false.toString(),
                    defaulted: true,
                    resettable: false,
                    updatedBy: '',
                    dateUpdated: ''
                }
                ],
                metadata: {
                    options: [{label: 'True', value: true.toString()}, {label: 'False', value: false.toString()}],
                    type: 'SELECT',
                    required: false,
                    localeSupport: false,
                    readOnly: true,
                },
                showLocaleIcons: false,
                isOverride: false,
                scope: 'GLOBAL',
                label: 'Locked'
            };
            this.formFields.push(lockedAttribute);
        }
    }

    ngAfterViewInit() {
        if (!this.attributes) {
            return
        }
        for (const attribute of this.attributes) {
            // Override showLocaleIcons if explicitly set via input
            if (this.showLocaleIcons === false) {
                attribute.showLocaleIcons = false;
            }
            this.formFields.push(attribute);
        }
        this.formFields$.next(this.formFields);
        this.form = this.fieldService.toManagementFormGroup(this.formFields, this.existingUpdates, this.isAdd,
            this.isDuplication);
        this.model = this.form.value;
        this.changeDetector.detectChanges();
    }

    hasChanges(): boolean {
        return this.form && this.form.dirty;
    }

    isFormReady(): boolean {
        return this.form && this.form.dirty && !this.form.invalid;
    }
}
